import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextIconBoxComponent } from './text-icon-box/text-icon-box.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatIconModule} from '@angular/material/icon';
import {UserViewModule} from './user-view/user-view.module';
import { CurrencySymbolPipe } from './currency-symbol.pipe';
import { CountrySelectorComponent } from './country-selector/country-selector.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {FormsModule} from '@angular/forms';
import { HarborSelectorComponent } from './harbor-selector/harbor-selector.component';
import {MatCardModule} from '@angular/material/card';
import { CurrencySelectorComponent } from './currency-selector/currency-selector.component';
import { AirPollutionBarComponent } from './air-pollution-bar/air-pollution-bar.component';
import { CurrenciesWidgetComponent } from './currencies-widget/currencies-widget.component';
import { AirPollutionSelectorComponent } from './air-pollution-selector/air-pollution-selector.component';
import { ContactUsButtonComponent } from './contact-us-button/contact-us-button.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {TranslateModule} from '@ngx-translate/core';
import { OrderStatusPipe } from './order-status.pipe';



@NgModule({
  declarations: [TextIconBoxComponent, CurrencySymbolPipe, CountrySelectorComponent, HarborSelectorComponent, CurrencySelectorComponent, AirPollutionBarComponent, CurrenciesWidgetComponent, AirPollutionSelectorComponent, ContactUsButtonComponent, OrderStatusPipe],
    exports: [
        TextIconBoxComponent,
        UserViewModule,
        CurrencySymbolPipe,
        CountrySelectorComponent,
        HarborSelectorComponent,
        CurrencySelectorComponent,
        AirPollutionBarComponent,
        CurrenciesWidgetComponent,
        ContactUsButtonComponent,
        OrderStatusPipe
    ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule,
    UserViewModule,
    NgSelectModule,
    AngularSvgIconModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    TranslateModule
  ]
})
export class FreightSharedModule { }
